import {useEffect} from 'react'
import {useIntl} from 'react-intl'
import { useMutation, useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { PageTitle} from '../../../_metronic/layout/core'
import { getConfigDetail, putConfigs, } from '../../modules/services/configs.service'
import FormConfig from './formConfig'



const ConfigurationPage = () => {
  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])
  const {data} = useQuery(['getConfig', "1"], async () => await getConfigDetail("1"))
 


  const initValue = {
    global_percentage: data?.attributes.global_percentage,
    conversion_currency: data?.attributes.conversion_currency,
    conversion_point: data?.attributes.conversion_point
  }

  const handleChange = (form: any) => {
    mutate(form)
  }

   const {mutate, isLoading} = useMutation(putConfigs, {
    onSuccess: async () => {
      toast.success("Update Data Success")
      // navigate('/loyalty-point/product')
        
    },
    onError(error : any, variables, context) {
      console.log('Error', error.response?.data)
      toast.error(error.response?.data?.error?.message)
    },
  })

  return (
    <>
      <div className='card mb-10'>
        <div className='card-body d-flex align-items-center py-8'>
          <div className='ms-6'>
            <p className='fw-bold fs-6 pb-4 m-0'>Loyalty Point</p>
            <FormConfig handleChange={handleChange} initLoad={initValue} loadings={isLoading}  />
          </div>
         
        </div>
      </div>
    </>
  )
}

const ConfigurationWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle>
        {intl.formatMessage({id: 'MENU.CONFIGURATION'})}
      </PageTitle>
      <ConfigurationPage />
    </>
  )
}

export default ConfigurationWrapper
